module.exports = __webpack_public_path__ + "img/tx2.cecd7885.jpg";